const prefix = 'drivex/experimentalFeatures';

const LOAD_EXPERIMENTAL_FEATURES_SUCCESS = `${prefix}/LOAD_EXPERIMENTAL_FEATURES_SUCCESS`;

export default {
  LOAD_EXPERIMENTAL_FEATURES_SUCCESS
};
